export const GET_WORKS_FIELDS = 'GET_WORKS_FIELDS';
export const GET_WORKS_FIELDS_SUCCESS = 'GET_WORKS_FIELDS_SUCCESS';
export const GET_WORKS_FIELDS_ERROR = 'GET_WORKS_FIELDS_ERROR';

export const GET_CITIES = 'GET_CITIES';
export const GET_CITIES_SUCCESS = 'GET_CITIES_SUCCESS';
export const GET_CITIES_ERROR = 'GET_CITIES_ERROR';

export const GET_EDUCATIONS_LEVEL = 'GET_EDUCATIONS_LEVEL';
export const GET_EDUCATIONS_LEVEL_SUCCESS = 'GET_EDUCATIONS_LEVEL_SUCCESS';
export const GET_EDUCATIONS_LEVEL_ERROR = 'GET_EDUCATIONS_LEVEL_ERROR';

export const GET_DOCUMENTS_TYPES = 'GET_DOCUMENTS_TYPES';
export const GET_DOCUMENTS_TYPES_SUCCESS = 'GET_DOCUMENTS_TYPES_SUCCESS';
export const GET_DOCUMENTS_TYPES_ERROR = 'GET_DOCUMENTS_TYPES_ERROR';
